var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-item',{attrs:{"genericData":_vm.blogSectionData}})
}
var staticRenderFns = []

export { render, staticRenderFns }